import api from './axios';

/**
 * 작업 목록 조회 (기간, 상태 필터)
 */
export const getJobs = async (startDate, endDate, status) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    if (status) params.status = status;
    const response = await api.get('/jobs', { params });
    return response.data.data;
};

/**
 * 단건 상세 조회
 */
export const getJob = async (id) => {
    const response = await api.get(`/jobs/${id}`);
    return response.data.data;
};

/**
 * 새 작업 생성 (예약 or 현장)
 */
export const createJob = async (jobData) => {
    const response = await api.post('/jobs', jobData);
    return response.data.data;
};

/**
 * 작업 수정 (상태 전이 포함)
 */
export const updateJob = async (id, updates) => {
    const response = await api.put(`/jobs/${id}`, updates);
    return response.data.data;
};

/**
 * 작업 삭제 (soft delete)
 */
export const deleteJob = async (id) => {
    const response = await api.delete(`/jobs/${id}`);
    return response.data.data;
};

/**
 * 매장 직원(작업자) 목록 조회
 */
export const fetchStaff = async () => {
    const response = await api.get('/jobs/staff');
    return response.data.data;
};

const jobApi = {
    getJobs,
    getJob,
    createJob,
    updateJob,
    deleteJob,
    fetchStaff
};

export default jobApi;
